import React from 'react';
import styles from './messageBox.module.css'
import {HiOutlineEmojiHappy} from 'react-icons/hi'
import {IoIosAttach} from 'react-icons/io'
import {BsCardImage} from 'react-icons/bs'
import {AiOutlineGif} from 'react-icons/ai'


const ChatAction =()=>{
    return(
        <div className={styles.chatActionContainer}>
            
            <div className={styles.cathActionIconCon}> 
            <IoIosAttach />
            <BsCardImage/>
            <AiOutlineGif/>
            <HiOutlineEmojiHappy/>
            </div>
            <button className={styles.sendButton}>send</button>
                  </div>
    )
}

export default ChatAction